import React from 'react'
// import { Link } from 'react-router-dom';


const Blog1=()=>{

    return(
        <>
  <section className="main-wrapper bg-grey">
    <div className="container">
      <div className="main-content mt-20 ov-hidden">
        <div className="col-md-8 sm-padding">
          <div className="blog-details padding-25 bg-white bd-grey mb-30">
            <h2 className="mb-5 fw-6">
              इसबार भी पनोरमा स्टार सीजन 07 का होगा आयोजन- संजीव मिश्रा
            </h2>
            <img
              src="img/sports/sabjee-misra.jpeg"
              alt="sanjeev-misra"
              className="img-w1"
            />
            <div className="meta-info mb-25 mt-5">
              <span className="mt-5">
                <i className="ti-calendar fz-18" />{" "}
                <a >31 Augest, 2024</a>
              </span>
            </div>
            {/* blog-details */}
            <p>
              पूर्णिया: मुख्यालय के जिला स्कूल रोड स्थित पनोरमा ग्रुप के
              कार्पोरेट कार्यालय में शनिवार को पनोरमा ग्रुप के प्रबंध निदेशक
              श्री संजीव मिश्रा ने प्रेसवार्ता कर जानकारी देते हुए कहा कि पनोरमा
              ग्रुप हर वर्ष की तरह इस वर्ष भी पनोरमा स्टार सीजन 07 का आयोजन करने
              जा रहा है जिसमें इस बार कई विधाओं को शामिल किया है जिसमे पनोरमा
              स्पोर्ट्स सीजन -7 में खिलाड़ियों एवं खेल प्रेमियों के विशेष आग्रह
              पर कुश्ती, कबड्डी, एथलेटिक्स, साइकिलिंग एवं हॉर्सराइटिंग खेलों को
              शामिल किया गया है।
            </p>
            <ol>
              नि: शुल्क प्रतियोगिता:-
              <li>1.क्रिकेट</li>
              <li>2. वॉलीबॉल</li>
              <li>3. बास्केटबॉल</li>
              <li>4. बैडमिंटन</li>
              <li>5. टेबुल टेनिस</li>
              <li>6. फुटबॉल </li>
              <li>7. कुश्ती</li>
              <li>8. कबड्डी </li>
              <li>9. एथलेटिक्स </li>
              <li>10. साइकिलिंग </li>
              <li>11. हॉर्सराइटिग</li>
              <li>12. शतरंज </li>
            </ol>
            <ol>
              {" "}
              प्रतियोगिता अंडर - 17 आयु वर्ग में बालक - बालिका आयु वर्ग के साथ -
              साथ एवं ओपन टू आल आयु वर्ग में खेला जाएगा। शतरंज प्रतियोगिता :-
              <li>1. अंडर -7</li>
              <li>2. अंडर -9</li>
              <li>3. अंडर -11</li>
              <li>4. अंडर -17</li>
            </ol>
            <ol>
              बालक , बालिका आयु वर्ग के साथ - साथ ओपन टू आल वर्ग में प्रतियोगिता
              खेला जाएगा । एथलेटिक्स प्रतियोगिता:-
              <li>1. 100 मीटर दौड़ </li>
              <li>2. 200 मीटर दौड़ </li>
              <li>3. 400 मीटर दौड़ </li>
              <li>4. 4.800 मीटर दौड़ </li>
              <li>5. 5.1500 मीटर दौड़ </li>
              <li>6. डिस्कस</li>
              <li>7. भाला ( जैवलिन) </li>
              <li>8. लंबी कूद </li>
              <li>9. ऊंची कूद</li>
              <li>10. गोला </li>
            </ol>
            {/* <img src="img/purniya-bihar-sanjay.jpg" alt="headlines bihar" width="600"> */}
            <p>
              अंडर -17 बालक, बालिका आयु वर्ग के साथ - साथ ओपन टू आल वर्ग में रखा
              गया है।
            </p>
            <p>
              पैनोरमा स्पोर्ट्स सीजन -7 दिनांक 22 सितंबर 2024 से पैनोरमा ई होम
              स्पोर्ट्स कॉम्प्लेक्स परिसर पूर्णिया में आयोजित होगा। प्रतियोगिता
              का समापन समारोह दिनांक 22 नवंबर 24 को रखा गया है। रजिस्ट्रेशन की
              अंतिम तिथि 15 सितंबर को रखा गया। सभी विधाओं के लिए नगद पुरस्कार
              राशि भी रखी गई हैं.
            </p>
            प्रेस कॉन्फ्रेंस में संजीव मिश्रा ने कहा पनोरमा स्टार सीजन 07
            कार्यक्रम में इस बार भी पूरे बिहार भर के बच्चे गायन, नृत्य, पेंटिंग,
            वेदमंंत्र, के साथ-साथ लोकनृत्य में समा चकेवा,जाट-जाटिन,बिहू, आदिवासी
            नृत्य, झिझिया इत्यादि को शामिल किया गया है संजीव मिश्रा ने कहा कि
            छोटे बच्चों के लिए जुनीयर मिस पनोरमा को भी विधा में शामिल किया गया
            है इसके लिए पनोरमा ग्रुप ने एक मोबाइल वाट्सएप नम्बर भी जारी किया है
            जो 7549000057 पर सम्पर्क कर अपना 20 सेकेण्ड से दो मिनट तक का विडियो
            क्लिप बनाकर भेज सकते हैं सलेक्ट विडियो क्लिप को देखकर हमारी टीम उस
            प्रतिभागियों को सूचित किया जाएगा। पनोरमा ग्रुप का प्रयास है कि कोशी
            सीमांचल सहित बिहार का ऐसे बच्चे जो कला के क्षेत्र में देश दुनिया में
            अपने नाम का लोहा मनवा सकें. प्रेस कॉन्फ्रेंस में पनोरमा ग्रुप के
            प्रबंध निदेशक श्री संजीव मिश्रा, सीईओ श्री नंदन झा, रितेश झा, विक्रम
            भगत,अनुज पाठक, आशुतोष,धीरज जैन, रंगकर्मी मिथिलेश राय, अमित, पनोरमा
            स्पोर्ट्स के खेल प्रशिक्षक हरिओम झा समेत अन्य लोग मौजूद थे।
            {/* ****************************************************content end ******************************************* */}
            <ul className="single-tags">
              <li>Tags</li>
              <li>
                <a >Sports</a>
              </li>
              <li>
                <a >Travel</a>
              </li>
            </ul>
            <div className="social-share-wrap">
              <span className="fz-16 text-black fw-6">Share This Article</span>
              <ul className="share-icon">
                <li>
                  <a >
                    <i className="ti-facebook" /> Facebook
                  </a>
                </li>
                <li>
                  <a >
                    <i className="ti-twitter" /> Twitter
                  </a>
                </li>
                <li>
                  <a >
                    <i className="ti-google" /> Google+
                  </a>
                </li>
              </ul>
            </div>
            {/* social-share-wrap */}
          </div>
          {/* /.blog-details */}
        </div>
        {/* content block */}
        <aside className="col-md-4 sm-padding">
          <div className="sidebar-wrap">
            <div className="single-sidebar no-padding">
              <a
                href="https://www.accuweather.com/en/us/new-york-ny/10007/weather-forecast/349727"
                className="aw-widget-legal"
              >
                {/*
                          By accessing and/or using this code snippet, you agree to AccuWeather’s terms and conditions (in English) which can be found at https://www.accuweather.com/en/free-weather-widgets/terms and AccuWeather’s Privacy Statement (in English) which can be found at https://www.accuweather.com/en/privacy.
                          */}
              </a>
              <div
                id="awcc1499974479079"
                className="aw-widget-current"
                data-locationkey=""
                data-unit="c"
                data-language="en-us"
                data-useip="true"
                data-uid="awcc1499974479079"
              />
            </div>
            {/* /.single-sidebar */}
            <div className="single-sidebar no-padding">
              <div className="side-tab">
                <ul className="tab-menu mb-15">
                  <li className="active">
                    <a href="#recent" data-toggle="tab">
                      Recent
                    </a>
                  </li>
                  <li>
                    <a href="#popular" data-toggle="tab">
                      Popular
                    </a>
                  </li>
                  <li>
                    <a href="#comments" data-toggle="tab">
                      Comments
                    </a>
                  </li>
                </ul>
                <div className="tab-content bd-grey padding-15">
                  <div className="tab-pane fade in active" id="recent">
                    <ul className="list-post-items">
                      <li>
                        <img src="img/tab-1.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >William Braynt went to visit the US.</a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2024
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-2.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              Style icon angelina goes to take oscar.
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2024
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-3.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              How to become a wildlife photographer?
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2024
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-4.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              linin park singer is no more. he is top in the
                              world.
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2024
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>{" "}
                  {/* /#recent */}
                  <div className="tab-pane fade in" id="popular">
                    <ul className="list-post-items">
                      <li>
                        <img src="img/tab-1.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2024
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-2.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2024
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-3.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2024
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-4.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2024
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>{" "}
                  {/* /#popular */}
                  <div className="tab-pane fade in" id="comments">
                    <ul className="list-post-items">
                      <li>
                        <img src="img/tab-1.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2024
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-2.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2024
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-3.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2024
                          </p>
                        </div>
                      </li>
                      <li>
                        <img src="img/tab-4.jpg" alt="Image" />
                        <div className="list-post-content bd-grey">
                          <h4 className="fz-14">
                            <a >
                              William Braynt went to visit the grabl
                            </a>
                          </h4>
                          <p className="fz-12 fw-6 tt-u no-margin">
                            national Octobar 2024
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>{" "}
                  {/* /#comments */}
                </div>
              </div>
            </div>
            {/* /.single-sidebar */}
            <div className="single-sidebar">
              <h3 className="fw-8 fz-18 tt-u mb-30">Subscribe News24</h3>
              <form action="#" className="subscribe-form">
                <input
                  type="email"
                  name="email"
                  placeholder="Enter Your Email"
                />
                <input type="submit" defaultValue="Subscribe" />
              </form>
            </div>
            {/* /.single-sidebar */}
            <div className="single-sidebar">
              <div id="calendar_wrap" className="calendar_wrap">
                <table id="wp-calendar">
                  <caption>Agust 2024</caption>
                  <thead>
                    <tr>
                      <th scope="col" title="Monday">
                        M
                      </th>
                      <th scope="col" title="Tuesday">
                        T
                      </th>
                      <th scope="col" title="Wednesday">
                        W
                      </th>
                      <th scope="col" title="Thursday">
                        T
                      </th>
                      <th scope="col" title="Friday">
                        F
                      </th>
                      <th scope="col" title="Saturday">
                        S
                      </th>
                      <th scope="col" title="Sunday">
                        S
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan={3} id="prev" className="pad">
                        &nbsp;
                      </td>
                      <td className="pad">&nbsp;</td>
                      <td colSpan={3} id="next" className="pad">
                        &nbsp;
                      </td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr>
                      <td colSpan={5} className="pad">
                        &nbsp;
                      </td>
                      <td>1</td>
                      <td>2</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>4</td>
                      <td>5</td>
                      <td>6</td>
                      <td>7</td>
                      <td>
                        <a
                          href="http://cracktheme.com/codehube/2024/07/08/"
                          aria-label="Posts published on July 8, 2024"
                        >
                          8
                        </a>
                      </td>
                      <td>9</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>11</td>
                      <td>
                        <a
                          href="http://cracktheme.com/codehube/2024/07/12/"
                          aria-label="Posts published on July 12, 2024"
                        >
                          12
                        </a>
                      </td>
                      <td>
                        <a
                          href="http://cracktheme.com/codehube/2024/07/13/"
                          aria-label="Posts published on July 13, 2024"
                        >
                          13
                        </a>
                      </td>
                      <td>14</td>
                      <td>15</td>
                      <td>16</td>
                    </tr>
                    <tr>
                      <td>17</td>
                      <td>18</td>
                      <td>19</td>
                      <td id="today">20</td>
                      <td>21</td>
                      <td>22</td>
                      <td>23</td>
                    </tr>
                    <tr>
                      <td>24</td>
                      <td>25</td>
                      <td>26</td>
                      <td>27</td>
                      <td>28</td>
                      <td>29</td>
                      <td>30</td>
                    </tr>
                    <tr>
                      <td>31</td>
                      <td className="pad" colSpan={6}>
                        &nbsp;
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/* /.single-sidebar */}
          </div>
          {/* /.sidebar-wrap */}
        </aside>
        {/* sidebar block */}
      </div>
      {/* /.main-content */}
    </div>
    {/* /.container */}
  </section>
  {/* /.main-wrapper */}
</>

    )
}

export default Blog1;